import { AcsesLogsTable } from "modules/AcsesLogsDashboard/components";

export const AcsesLogsDashboard = () => <AcsesLogsTable />;
